import React, { CSSProperties } from 'react';

const contentStyle:CSSProperties = {
  opacity: 0.9,
  fontSize: '1.1em',
};

export function PlainMessage(props: {messages:string[]|string, title:string}) {
  const m = props.messages instanceof Array ? props.messages : [props.messages];
  return (
    <div>
      <h1 style={contentStyle}>{props.title}</h1>
      {m.map((e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={`line-${i}`} style={contentStyle}>
          {e}
          <br />
        </span>
      ))}
    </div>
  );
}
